export const isTeamUserAdmin = (userRole) => {
    return userRole === "admin"
}